export enum MARKETPLACE_CATEGORY {
    FOOD = "Food",
    GIFTING = "GIFTING",
}

export enum MARKETPLACE_BUSINESS_LINE {
    REGULAR = "Regular",
    GIFTING = "GIFTING",
}

export enum MARKETPLACE_ID {
    SWIGGY = 1,
}
